import http from 'hub-http/clients/apiClient';
export function isEligibleForSupport(threadId) {
  return http.get(`conversations-routing/v1/eligibility/${threadId}/support`);
}
export function relocateToSupport(threadId) {
  return http.post(`conversations-routing/v1/route/${threadId}/support-inbox`);
}